import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, nullsafe } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.FacturaDto;
type Column = kea.Grid2Column<Entity>;

/**Columnas fijas del grid */
const columnasFijas: Column[] = [
    { title: "Folio", cell: x => ({ data: x.SerieFolio }) },
    { title: "Cliente", cell: x => ({ data: x.NombreCliente }) },
    { title: "Pagada", cell: x => ({ data: x.EsPPDPagada }) },
    { title: "Cancelado", cell: x => ({ data: x.EsCancelada }) },
    { title: "Fecha creación", cell: x => ({ data: kea.toDate(x.FechaCreacion) }) },
    { title: "Sucursal de cobranza", cell: x => ({ data: x.NombreSucursalCobranza }) },
    { title: "Saldo", cell: x => ({ data: x.Saldo, view: kea.formatCurrency }) },
    { title: "Total", cell: x => ({ data: x.ImporteTotal, view: kea.formatCurrency }) },
    { title: "REPs", cell: x => ({ data: x.FolioReps }) },
    { title: "Fecha de pago", cell: x => ({ data: kea.toDate(x.FechaPago) }) },
    { title: "Pagada sin REP", cell: x => ({ data: x.PagadaSinRep }) },
    { title: "PUE pero crédito", cell: x => ({ data: x.PuePeroCredito }) },
    { title: "PPD pero contado", cell: x => ({ data: x.PpdPeroContado }) },
];

export interface BotonesDeps {

}

/**Obtiene las columnas del grid */
export function columnas(deps: BotonesDeps): Column[] {
    return [...columnasFijas];
}




// WEBPACK FOOTER //
// ./app/features/general/operativa/items/facturas/cancelacionmultiple/columns.tsx